<template>
  <Collapse
    v-if="histories.length"
    class="tenant-submission-comment-history"
    :expand="false"
    :withBorder="false"
  >
    <div
      slot="title"
      class="comment-title"
    >
      {{ $t('tenantProjects.sendHistory') }}
    </div>
    <table
      slot="content"
      class="history-table"
    >
      <thead>
        <tr>
          <th
            v-for="(header, index) in historyHeaders"
            :key="index"
            :class="header.class"
          >
            {{ header.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(history, index) in histories"
          :key="index"
        >
          <td>{{ history.createdBy.displayName }}</td>
          <td>{{ history.emailReceivers.to.replace(/;/g, '; ') }}</td>
          <td>{{ history.emailReceivers.cc.replace(/;/g, '; ') }}</td>
          <td>{{ history.emailReceivers.bcc.replace(/;/g, '; ') }}</td>
          <td style="white-space: nowrap;">
            {{ history.actionType | customStatusLabel | capitalize }}
          </td>
          <td>{{ dateUtil.formatDate(history.createdAt, true) }}</td>
        </tr>
      </tbody>
    </table>
  </Collapse>
</template>

<script>
import Collapse from '@/controls/Collapse'
import dateUtil from '@/utils/dateUtil'
import { PF_HISTORY_ACTION_TYPE } from './consts'
import { computed, inject, unref } from 'vue-demi'
import { DEPENDENCY_KEYS } from '../consts'
import i18n from '@/utils/i18n'

export default {
  name: 'PostFitOutCommentHistory',
  components: {
    Collapse,
  },
  setup () {
    const currentSubmission = inject(DEPENDENCY_KEYS.CURRENT_SUBMISSION)

    const historyHeaders = [{
      title: i18n.t('sender'),
    }, {
      title: i18n.t('to'),
    }, {
      title: i18n.t('cc'),
    }, {
      title: i18n.t('bcc'),
    }, {
      title: i18n.t('tenancyProject.status'),
    }, {
      title: i18n.t('time'),
    }]
    const histories = computed(() => unref(currentSubmission)
      .histories
      .filter(rec => [PF_HISTORY_ACTION_TYPE.SEND, PF_HISTORY_ACTION_TYPE.RESEND].includes(rec.actionType)),
    )
    return {
      historyHeaders,
      histories,
      dateUtil,
      submission: currentSubmission,
    }
  },
}
</script>

<style lang="scss" scoped>
.tenant-submission-comment-history {
  ::v-deep .title-container {
    border-bottom: 1px solid #e0e0e0;
  }

  .comment-title {
    font-weight: bold;
  }
  .history-table {
    table-layout: fixed;
  }
}
</style>
